// Static imports for core-lib ICON SVGs only (not logos or larger assets)
import iconAccountMyAccount from '~coreImages/svgs/icon__account--my-account.svg?inline';
import iconAccountPromo from '~coreImages/svgs/icon__account--promo.svg?inline';
import iconCatalogFilter from '~coreImages/svgs/icon__catalog--filter.svg?inline';
import iconGlobalAlert from '~coreImages/svgs/icon__global--alert.svg?inline';
import iconGlobalCalendar from '~coreImages/svgs/icon__global--calendar.svg?inline';
import iconGlobalCheckmarkBordered from '~coreImages/svgs/icon__global--checkmark-bordered.svg?inline';
import iconGlobalCheckmark from '~coreImages/svgs/icon__global--checkmark.svg?inline';
import iconGlobalChevron from '~coreImages/svgs/icon__global--chevron.svg?inline';
import iconGlobalClose from '~coreImages/svgs/icon__global--close.svg?inline';
import iconGlobalCopy from '~coreImages/svgs/icon__global--copy.svg?inline';
import iconGlobalCycle from '~coreImages/svgs/icon__global--cycle.svg?inline';
import iconGlobalEdit from '~coreImages/svgs/icon__global--edit.svg?inline';
import iconGlobalExternalLink from '~coreImages/svgs/icon__global--external-link.svg?inline';
import iconGlobalEye from '~coreImages/svgs/icon__global--eye.svg?inline';
import iconGlobalFieldClearWhite from '~coreImages/svgs/icon__global--field-clear-white.svg?inline';
import iconGlobalFieldClear from '~coreImages/svgs/icon__global--field-clear.svg?inline';
import iconGlobalHanger from '~coreImages/svgs/icon__global--hanger.svg?inline';
import iconGlobalHeartUnfilled from '~coreImages/svgs/icon__global--heart-unfilled.svg?inline';
import iconGlobalMapPin from '~coreImages/svgs/icon__global--map-pin.svg?inline';
import iconGlobalMenu from '~coreImages/svgs/icon__global--menu.svg?inline';
import iconGlobalMinus from '~coreImages/svgs/icon__global--minus.svg?inline';
import iconGlobalPlaceholder from '~coreImages/svgs/icon__global--placeholder.svg?inline';
import iconGlobalPlayButton from '~coreImages/svgs/icon__global--play-button.svg?inline';
import iconGlobalPlusThick from '~coreImages/svgs/icon__global--plus-thick.svg?inline';
import iconGlobalPlus from '~coreImages/svgs/icon__global--plus.svg?inline';
import iconGlobalRightArrow from '~coreImages/svgs/icon__global--right-arrow.svg?inline';
import iconGlobalSearch from '~coreImages/svgs/icon__global--search.svg?inline';
import iconGlobalSettings from '~coreImages/svgs/icon__global--settings.svg?inline';
import iconGlobalShare from '~coreImages/svgs/icon__global--share.svg?inline';
import iconGlobalSort from '~coreImages/svgs/icon__global--sort.svg?inline';
import iconGlobalStarHalf from '~coreImages/svgs/icon__global--star-half.svg?inline';
import iconGlobalStar from '~coreImages/svgs/icon__global--star.svg?inline';
import iconGlobalTooltip from '~coreImages/svgs/icon__global--tooltip.svg?inline';
import iconGlobalTruck from '~coreImages/svgs/icon__global--truck.svg?inline';
import iconMessageEmpty from '~coreImages/svgs/icon__message--empty.svg?inline';
import iconSocialFacebook from '~coreImages/svgs/icon__social--facebook.svg?inline';
import iconSocialInstagram from '~coreImages/svgs/icon__social--instagram.svg?inline';
import iconSocialLinkedin from '~coreImages/svgs/icon__social--linkedin.svg?inline';
import iconSocialPinterest from '~coreImages/svgs/icon__social--pinterest.svg?inline';
import iconSocialTiktok from '~coreImages/svgs/icon__social--tiktok.svg?inline';
import iconSocialTwitter from '~coreImages/svgs/icon__social--twitter.svg?inline';
import iconSocialYoutube from '~coreImages/svgs/icon__social--youtube.svg?inline';
import iconMediaPause from '~coreImages/svgs/icon__media--pause.svg?inline';
import iconMediaPlay from '~coreImages/svgs/icon__media--play.svg?inline';
import iconMediaReplay from '~coreImages/svgs/icon__media--replay.svg?inline';

export const ICON_REGISTRY = {
    'icon__account--my-account.svg': iconAccountMyAccount,
    'icon__account--promo.svg': iconAccountPromo,
    'icon__catalog--filter.svg': iconCatalogFilter,
    'icon__global--alert.svg': iconGlobalAlert,
    'icon__global--calendar.svg': iconGlobalCalendar,
    'icon__global--checkmark-bordered.svg': iconGlobalCheckmarkBordered,
    'icon__global--checkmark.svg': iconGlobalCheckmark,
    'icon__global--chevron.svg': iconGlobalChevron,
    'icon__global--close.svg': iconGlobalClose,
    'icon__global--copy.svg': iconGlobalCopy,
    'icon__global--cycle.svg': iconGlobalCycle,
    'icon__global--edit.svg': iconGlobalEdit,
    'icon__global--external-link.svg': iconGlobalExternalLink,
    'icon__global--eye.svg': iconGlobalEye,
    'icon__global--field-clear-white.svg': iconGlobalFieldClearWhite,
    'icon__global--field-clear.svg': iconGlobalFieldClear,
    'icon__global--hanger.svg': iconGlobalHanger,
    'icon__global--heart-unfilled.svg': iconGlobalHeartUnfilled,
    'icon__global--map-pin.svg': iconGlobalMapPin,
    'icon__global--menu.svg': iconGlobalMenu,
    'icon__global--minus.svg': iconGlobalMinus,
    'icon__global--placeholder.svg': iconGlobalPlaceholder,
    'icon__global--play-button.svg': iconGlobalPlayButton,
    'icon__global--plus-thick.svg': iconGlobalPlusThick,
    'icon__global--plus.svg': iconGlobalPlus,
    'icon__global--right-arrow.svg': iconGlobalRightArrow,
    'icon__global--search.svg': iconGlobalSearch,
    'icon__global--settings.svg': iconGlobalSettings,
    'icon__global--share.svg': iconGlobalShare,
    'icon__global--sort.svg': iconGlobalSort,
    'icon__global--star-half.svg': iconGlobalStarHalf,
    'icon__global--star.svg': iconGlobalStar,
    'icon__global--tooltip.svg': iconGlobalTooltip,
    'icon__global--truck.svg': iconGlobalTruck,
    'icon__message--empty.svg': iconMessageEmpty,
    'icon__social--facebook.svg': iconSocialFacebook,
    'icon__social--instagram.svg': iconSocialInstagram,
    'icon__social--linkedin.svg': iconSocialLinkedin,
    'icon__social--pinterest.svg': iconSocialPinterest,
    'icon__social--tiktok.svg': iconSocialTiktok,
    'icon__social--twitter.svg': iconSocialTwitter,
    'icon__social--youtube.svg': iconSocialYoutube,
    'icon__media--pause.svg': iconMediaPause,
    'icon__media--play.svg': iconMediaPlay,
    'icon__media--replay.svg': iconMediaReplay,
};

export const GLOBAL_ICONS = new Map([
    ['account--promo', { altText: 'promo icon', svgContent: iconAccountPromo }],
    ['account--my-account', { altText: 'person icon', svgContent: iconAccountMyAccount }],
    ['catalog--filter', { altText: 'filter icon', svgContent: iconCatalogFilter }],
    ['global--alert', { altText: 'alert icon', svgContent: iconGlobalAlert }],
    ['global--heart-unfilled', { altText: 'heart icon', svgContent: iconGlobalHeartUnfilled }],
    ['global--calendar', { altText: 'calendar icon', svgContent: iconGlobalCalendar }],
    ['global--checkmark', { altText: 'checkmark icon', svgContent: iconGlobalCheckmark }],
    ['global--checkmark-bordered', { altText: 'checkmark icon', svgContent: iconGlobalCheckmarkBordered }],
    ['global--chevron', { altText: 'chevron icon', svgContent: iconGlobalChevron }],
    ['global--close', { altText: 'close icon', svgContent: iconGlobalClose }],
    ['global--copy', { altText: 'copy icon', svgContent: iconGlobalCopy }],
    ['global--cycle', { altText: 'cycle icon', svgContent: iconGlobalCycle }],
    ['global--external-link', { altText: 'external link icon', svgContent: iconGlobalExternalLink }],
    ['global--field-clear', { altText: 'clear icon', svgContent: iconGlobalFieldClear }],
    ['global--field-clear-white', { altText: 'clear icon', svgContent: iconGlobalFieldClearWhite }],
    ['global--hanger', { altText: 'hanger icon', svgContent: iconGlobalHanger }],
    ['global--map-pin', { altText: 'map pin icon', svgContent: iconGlobalMapPin }],
    ['global--menu', { altText: 'hamburger menu icon', svgContent: iconGlobalMenu }],
    ['global--minus', { altText: 'minus icon', svgContent: iconGlobalMinus }],
    ['global--play-button', { altText: 'play media icon', svgContent: iconGlobalPlayButton }],
    ['global--placeholder', { altText: 'placeholder icon', svgContent: iconGlobalPlaceholder }],
    ['global--plus', { altText: 'plus icon', svgContent: iconGlobalPlus }],
    ['global--plus-thick', { altText: 'plus icon', svgContent: iconGlobalPlusThick }],
    ['global--edit', { altText: 'edit icon', svgContent: iconGlobalEdit }],
    ['global--right-arrow', { altText: 'right arrow icon', svgContent: iconGlobalRightArrow }],
    ['global--search', { altText: 'search icon', svgContent: iconGlobalSearch }],
    ['global--settings', { altText: 'settings icon', svgContent: iconGlobalSettings }],
    ['global--share', { altText: 'share icon', svgContent: iconGlobalShare }],
    ['global--sort', { altText: 'dropdown icon icon', svgContent: iconGlobalSort }],
    ['global--star', { altText: 'star icon', svgContent: iconGlobalStar }],
    ['global--star-half', { altText: 'half-star icon', svgContent: iconGlobalStarHalf }],
    ['global--tooltip', { altText: 'tooltip icon', svgContent: iconGlobalTooltip }],
    ['global--truck', { altText: 'truck icon', svgContent: iconGlobalTruck }],
    ['global--eye', { altText: 'eye icon', svgContent: iconGlobalEye }],
    ['message--empty', { altText: 'message icon', svgContent: iconMessageEmpty }],
    ['social--facebook', { altText: 'facebook icon', svgContent: iconSocialFacebook }],
    ['social--instagram', { altText: 'instagram icon', svgContent: iconSocialInstagram }],
    ['social--linkedin', { altText: 'linkedin icon', svgContent: iconSocialLinkedin }],
    ['social--pinterest', { altText: 'pinterest icon', svgContent: iconSocialPinterest }],
    ['social--tiktok', { altText: 'tiktok icon', svgContent: iconSocialTiktok }],
    ['social--twitter', { altText: 'twitter icon', svgContent: iconSocialTwitter }],
    ['social--youtube', { altText: 'youtube icon', svgContent: iconSocialYoutube }],
    ['media--pause', { altText: 'pause icon', svgContent: iconMediaPause }],
    ['media--play', { altText: 'play icon', svgContent: iconMediaPlay }],
    ['media--replay', { altText: 'replay icon', svgContent: iconMediaReplay }],
]);

export default GLOBAL_ICONS;
